import cx from 'classnames';

import { VehicleExteriorGradeIcon } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import type { VehicleData } from 'Pages/vehicles/helpers/vehicle.schema';
import { formatText } from 'Utilities/formatters';
import { applyTestIdData } from 'Utilities/helpers';

import { BackgroundLayout } from '../BackgroundLayout/BackgroundLayout';
import { NumericGradingText } from '../NumericGradingText/NumericGradingText';

import { RatingItem } from './RatingItem/RatingItem';

import styles from './VehicleRatings.module.scss';

export const ServiceHistoryMap = {
	'-': '-',
	full: 'Full',
	no: 'None',
	not_applicable: 'Not due',
	partial: 'Partial',
	skipped: '-',
	yes: 'Available',
};

interface RatingsSectionProps {
	analyticsCategory?: string;
	clickableLinks?: boolean;
	legacyGrade?: VehicleData['ratings']['grade'];
	numericGrade?: VehicleData['ratings']['numericGrade'];
	onNavigateGrading?: () => void;
	previousOwners: VehicleData['ratings']['previousOwners'];
	serviceHistory: VehicleData['ratings']['serviceHistory'];
}

export const VehicleRatings: React.FC<RatingsSectionProps> = ({
	analyticsCategory,
	clickableLinks = true,
	legacyGrade,
	numericGrade,
	previousOwners,
	serviceHistory,
}) => {
	const hasLegacyGrade = legacyGrade && legacyGrade !== '-';

	return (
		<BackgroundLayout backgroundColour="light" border="none" className={styles.layout}>
			<section className={styles.container} {...applyTestIdData(cypressIds.containers.vehicleRatings)}>
				<RatingItem
					analyticsCategory={analyticsCategory}
					clickableLinks={clickableLinks}
					id="vehicleDetails"
					text="Previous owners"
				>
					{previousOwners}
				</RatingItem>
				<RatingItem
					analyticsCategory={analyticsCategory}
					clickableLinks={clickableLinks}
					id="serviceHistory"
					text="Service history"
				>
					{ServiceHistoryMap[serviceHistory]}
				</RatingItem>
				<RatingItem
					analyticsCategory={analyticsCategory}
					clickableLinks={clickableLinks}
					id="conditionAndDamage"
					text="Grading"
				>
					{numericGrade ? (
						<NumericGradingText grade={numericGrade} size={'regular'} />
					) : (
						<>
							{hasLegacyGrade && (
								<span className={cx([styles.grading, legacyGrade && styles[legacyGrade]])}>
									<VehicleExteriorGradeIcon size="xsmall" />
								</span>
							)}
							{hasLegacyGrade ? formatText(legacyGrade) : '-'}
						</>
					)}
				</RatingItem>
			</section>
		</BackgroundLayout>
	);
};
